<template lang="pug">
b-modal#getMessageList(
  ref="getMessageList"
  :title="$t('ui.combine.get_message_list')"
  centered
  no-fade
  no-close-on-backdrop
  size="xl"
  :busy="loading"
  ok-only
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    div
      .row.mt-2
        .col-10.mb-1
          b-pagination.float-left(
            size="sm"
            hide-ellipsis
            :total-rows="totalRowMessageList"
            :per-page="getPageSizeMessageList"
            v-model="currentPageMessageList"
            @input="changedPage($event)"
          )
        .col-2.mb-1
          b-input-group(:prepend="$t('ui.page_size')" size="sm")
            b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSizeMessageList" @input="changedPageSize" size="sm")
        .col
          .clusterize-scroll.table-responsive
            table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
              thead.thead-light
                tr
                  th.text-center(width="3%")
                    span #
                  th(width="18%")
                    span {{ $t('ui.title') }}
                  th
                    span {{ $t('ui.body') }}
                  th.text-right(width="14%" @click="sortOrder('created_at')")
                    span(:title="$t('ui.created_at')") {{ $t('ui.created_at') }}
                    .float-right
                      i(:class="changeSortKey('created_at')")
              tbody
                tr(v-if="messageList.length == 0")
                  td(colspan="4").text-center
                    span {{ $t('message.no_data_available') }}
                tr(v-for="(item, index) in messageList")
                  td.text-center
                    span(:title="index + 1") {{ index + 1 }}
                  td
                    span(:title="messageTitle(item)") {{ messageTitle(item) }}
                  td
                    span.message-list-body(:title="messageBody(item)") {{ messageBody(item) }}
                  td.text-right
                    span(v-if="messageCreatedAt(item)" :title="formatDt(messageCreatedAt(item))") {{ formatDt(messageCreatedAt(item)) }}
    .row
      .col-12
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fas fa-check" :text="$t('ui.ok')" isModal=true)
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";

export default {
  components: {
    SubmitButton
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      account_id: "",
      messageList: [],
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      currentPageMessageList: 1,
      totalRowMessageList: 0,
      getPageSizeMessageList: 10,
      sortKeyMessageList: "created_at",
      sortTypeMessageList: "desc"
    };
  },
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    }
  },
  methods: {
    messageTitle(row) {
      if (!row || typeof row !== "object") return "";
      return row.title != null && row.title !== "" ? row.title : (row.msg_title != null ? row.msg_title : "");
    },
    messageBody(row) {
      if (!row || typeof row !== "object") return "";
      const b = row.body != null && row.body !== "" ? row.body : (row.msg_body != null ? row.msg_body : "");
      return String(b);
    },
    messageCreatedAt(row) {
      if (!row || typeof row !== "object") return null;
      return row.created_at != null ? row.created_at : (row.created_date != null ? row.created_date : null);
    },
    formatDt(val) {
      if (!val) return "";
      return this.$moment(val).format("YYYY-MM-DD, HH:mm:ss");
    },
    sortOrder(key) {
      if (this.sortKeyMessageList == key)
        this.sortTypeMessageList = this.sortTypeMessageList == "asc" ? "desc" : "asc";
      else {
        this.sortKeyMessageList = key;
        this.sortTypeMessageList = "asc";
      }
      this.getMessageList(true);
    },
    changeSortKey(key) {
      if (this.sortKeyMessageList != key) return "fas fa-sort";
      if (this.sortKeyMessageList == key && this.sortTypeMessageList == "asc") return "fa fa-sort-up";
      if (this.sortKeyMessageList == key && this.sortTypeMessageList == "desc") return "fa fa-sort-down";
      return "fas fa-sort";
    },
    getMessageList(resetPage) {
      let url = config.messageListUrl();

      if (resetPage) this.currentPageMessageList = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        member_id: this.item.account_id,
        sort_key: this.sortKeyMessageList,
        sort_type: this.sortTypeMessageList,
        page_number: this.currentPageMessageList,
        page_size: this.getPageSizeMessageList
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          try {
            if (response) {
              this.feedback.success =
                typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.messageList = response.data.dt || [];
                this.totalRowMessageList =
                  this.messageList.length > 0 && this.messageList[0].totalrows != null ? this.messageList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status))
                  this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    reset() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown() {
      this.account_id = this.item.account_id;
      this.currentPageMessageList = 1;
      this.totalRowMessageList = 0;
      this.getPageSizeMessageList = 10;
      this.sortKeyMessageList = "created_at";
      this.sortTypeMessageList = "desc";
      this.getMessageList();
    },
    changedPageSize(pageSize) {
      this.getPageSizeMessageList = pageSize;
      this.currentPageMessageList = 1;
      this.getMessageList(true);
    },
    changedPage(pageNo) {
      this.currentPageMessageList = pageNo;
      this.getMessageList();
    }
  }
};
</script>

<style scoped>
.message-list-body {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
  line-height: 1.35;
}
</style>
